// react
import React from "react";
// components
import { Button, Icon } from "semantic-ui-react";

// component
function ButtonAddClick({ text, onClick }) {
    // template
    return (
        <Button
            type="button"
            labelPosition="left"
            size="large"
            color="pink"
            icon
            onClick={onClick}
        >
            <Icon name="plus" /> {text}
        </Button>
    );
}

export default ButtonAddClick;
